import { ReactComponent as DollFront } from "../assets/images/doll_front.svg";
import IconsEnum from "../classes/enums/IconsEnum";
import { ReactComponent as Osteotomies } from "../icons//Osteotomies.svg";
import { ReactComponent as ThreeD } from "../icons/3D.svg";
import { ReactComponent as ActivityTracking } from "../icons/ActivityTracking.svg";
import { ReactComponent as Add } from "../icons/Add.svg";
import { ReactComponent as AddVertebra } from "../icons/AddVertebra.svg";
import { ReactComponent as Angle } from "../icons/Angle.svg";
import { ReactComponent as Angle4Points } from "../icons/Angle4Points.svg";
import { ReactComponent as AngleCOBB } from "../icons/AngleCobb.svg";
import { ReactComponent as AngleComp } from "../icons/AngleComp.svg";
import { ReactComponent as AngleGeneric } from "../icons/AngleGeneric.svg";
import { ReactComponent as AngleHorizontal } from "../icons/AngleHorizontal.svg";
import { ReactComponent as AngleInner } from "../icons/AngleInner.svg";
import { ReactComponent as AngleKYPHOSIS } from "../icons/AngleKyphosis.svg";
import { ReactComponent as AngleLORDOSIS } from "../icons/AngleLordosis.svg";
import { ReactComponent as AngleVertical } from "../icons/AngleVertical.svg";
import { ReactComponent as Anonymization } from "../icons/Anonymization.svg";
import { ReactComponent as ARIcon } from "../icons/ARIcon.svg";
import { ReactComponent as Assistant } from "../icons/Assistant.svg";
import { ReactComponent as AttachDocument } from "../icons/AttachDocument.svg";
import { ReactComponent as AxialPlane } from "../icons/AxialPlane.svg";
import { ReactComponent as BodyBack } from "../icons/BodyBack.svg";
import { ReactComponent as BodyFront } from "../icons/BodyFront.svg";
import { ReactComponent as BodyLayers } from "../icons/BodyLayers.svg";
import { ReactComponent as Brightness } from "../icons/Brightness.svg";
import { ReactComponent as Cages } from "../icons/Cages.svg";
import { ReactComponent as Calendar } from "../icons/Calendar.svg";
import { ReactComponent as Camera } from "../icons/Camera.svg";
import { ReactComponent as Chat } from "../icons/Chat.svg";
import { ReactComponent as ClearFilter } from "../icons/ClearFilter.svg";
import { ReactComponent as ClinicalData } from "../icons/ClinicalData.svg";
import { ReactComponent as Close } from "../icons/Close.svg";
import { ReactComponent as Compare } from "../icons/Compare.svg";
import { ReactComponent as Confirm } from "../icons/Confirm.svg";
import { ReactComponent as ContactForm } from "../icons/ContactForm.svg";
import { ReactComponent as CoronalPlane } from "../icons/CoronalPlane.svg";
import { ReactComponent as Crop } from "../icons/Crop.svg";
import { ReactComponent as DataFusion } from "../icons/DataFusion.svg";
import { ReactComponent as Delete } from "../icons/Delete.svg";
import { ReactComponent as DollVerified } from "../icons/DollVerified.svg";

import { ReactComponent as AddLandmark } from "../icons/AddLandmark.svg";
import { ReactComponent as Brush } from "../icons/Brush.svg";
import { ReactComponent as Circle } from "../icons/Circle.svg";
import { ReactComponent as CompareDigitalTwin } from "../icons/CompareDigitalTwin.svg";
import { ReactComponent as Decompensation } from "../icons/Decompensation.svg";
import { ReactComponent as DistanceGeneric } from "../icons/DistanceGeneric.svg";
import { ReactComponent as DistanceHorizontal } from "../icons/DistanceHorizontal.svg";
import { ReactComponent as DistanceVertical } from "../icons/DistanceVertical.svg";
import { ReactComponent as Documentation } from "../icons/Documentation.svg";
import { ReactComponent as DownArrow } from "../icons/DownArrow.svg";
import { ReactComponent as Drag } from "../icons/Drag.svg";
import { ReactComponent as Duplicate } from "../icons/Duplicate.svg";
import { ReactComponent as Edit } from "../icons/Edit.svg";
import { ReactComponent as Email } from "../icons/Email.svg";
import { ReactComponent as Eraser } from "../icons/Eraser.svg";
import { ReactComponent as ExitFullscreen } from "../icons/ExitFullscreen_icon.svg";
import { ReactComponent as Expand } from "../icons/Expand_Icon.svg";
import { ReactComponent as Export } from "../icons/Export.svg";
import { ReactComponent as Eye } from "../icons/Eye.svg";
import { ReactComponent as Favorite } from "../icons/Favorite.svg";
import { ReactComponent as Folder } from "../icons/Folder.svg";
import { ReactComponent as GoBack } from "../icons/GoBack.svg";
import { ReactComponent as Grid } from "../icons/Grid.svg";
import { ReactComponent as Hardware } from "../icons/Hardware.svg";
import { ReactComponent as Help } from "../icons/Help.svg";
import { ReactComponent as Hide } from "../icons/Hide.svg";
import { ReactComponent as History } from "../icons/History.svg";
import { ReactComponent as Import } from "../icons/Import.svg";
import { ReactComponent as Info } from "../icons/Info.svg";
import { ReactComponent as Join } from "../icons/Join.svg";
import { ReactComponent as LayingPosition } from "../icons/LayingPosition.svg";
import { ReactComponent as Lock } from "../icons/Lock=Locked.svg";
import { ReactComponent as Unlock } from "../icons/Lock=Unlocked.svg";
import { ReactComponent as Logout } from "../icons/Logout.svg";
import { ReactComponent as Measurements } from "../icons/Measurements.svg";
import { ReactComponent as MedicalImages } from "../icons/MedicalImages.svg";
import { ReactComponent as ModalitySync } from "../icons/ModalitySync.svg";
import { ReactComponent as Next } from "../icons/Next.svg";
import { ReactComponent as OsteotomyTool } from "../icons/OsteotomyTool.svg";
import { ReactComponent as PainAssessment } from "../icons/PainAssessment.svg";
import { ReactComponent as PatientIndicators } from "../icons/PatientIndicators.svg";
import { ReactComponent as PatientMorphology } from "../icons/PatientMorphology.svg";
import { ReactComponent as Pen } from "../icons/Pen.svg";
import { ReactComponent as PersonalInformation } from "../icons/PersonalInfo.svg";
import { ReactComponent as PhoneNumber } from "../icons/PhoneNumber.svg";
import { ReactComponent as Photo } from "../icons/Photo_Icon.svg";
import { ReactComponent as Position } from "../icons/Position.svg";
import { ReactComponent as Profile } from "../icons/ProfileIcon.svg";
import { ReactComponent as Radiodensity } from "../icons/Radiodensity.svg";
import { ReactComponent as Redo } from "../icons/Redo.svg";
import { ReactComponent as Reflect } from "../icons/Reflect.svg";
import { ReactComponent as RemoveVertebra } from "../icons/RemoveVertebra.svg";
import { ReactComponent as Reports } from "../icons/Reports.svg";
import { ReactComponent as Reset } from "../icons/Reset.svg";
import { ReactComponent as ResetView } from "../icons/ResetView.svg";
import { ReactComponent as Resize } from "../icons/Resize.svg";
import { ReactComponent as RodLeftDisabled } from "../icons/RodLeftDisabled.svg";
import { ReactComponent as RodLeftEnabled } from "../icons/RodLeftEnabled.svg";
import { ReactComponent as RodRightDisabled } from "../icons/RodRightDisabled.svg";
import { ReactComponent as RodRightEnabled } from "../icons/RodRightEnabled.svg";
import { ReactComponent as Rods } from "../icons/Rods.svg";
import { ReactComponent as SagittalPlane } from "../icons/SagittalPlane.svg";
import { ReactComponent as Security } from "../icons/Security.svg";
import { ReactComponent as SecurityUnlocked } from "../icons/SecurityUnlocked.svg";
import { ReactComponent as Settings } from "../icons/Settings.svg";
import { ReactComponent as ShieldChecked } from "../icons/ShieldChecked.svg";
import { ReactComponent as Show } from "../icons/Show.svg";
import { ReactComponent as SittingPosition } from "../icons/SittingPosition.svg";
import { ReactComponent as Spine } from "../icons/Spine.svg";
import { ReactComponent as Spondy } from "../icons/Spondy.svg";
import { ReactComponent as Spp } from "../icons/Spp.svg";
import { ReactComponent as Square } from "../icons/Square.svg";
import { ReactComponent as Support } from "../icons/Support.svg";
import { ReactComponent as SurveyResults } from "../icons/SurveyResults.svg";
import { ReactComponent as Undo } from "../icons/Undo.svg";
import { ReactComponent as UpArrow } from "../icons/UpArrow.svg";
import { ReactComponent as Video } from "../icons/Video.svg";
import { ReactComponent as Videochat } from "../icons/Videochat.svg";
import { ReactComponent as Website } from "../icons/Website.svg";

import { ReactComponent as Download } from "../icons/Download.svg";
import { ReactComponent as Upload } from "../icons/Upload.svg";
import { ReactComponent as CEMarkManufacturer } from "../icons/CEMarkManufacturer.svg";
import { ReactComponent as CEMarkMedicalDevice } from "../icons/CEMarkMedicalDevice.svg";
import { ReactComponent as CEMarkNotifiedBody } from "../icons/CEMarkNotifiedBody.svg";
import { ReactComponent as CEMarkUDI } from "../icons/CEMarkUDI.svg";
import { ReactComponent as CEMarkWarming } from "../icons/CEMarkWarming.svg";
import { ReactComponent as CEMarkBookInfo } from "../icons/CEMarkBookInfo.svg";

export const iconMapping = {
  [IconsEnum.ADD]: Add,
  [IconsEnum.ANONYMIZATION]: Anonymization,
  [IconsEnum.ASSISTANT]: Assistant,
  [IconsEnum.AR]: ARIcon,
  [IconsEnum.ATTACHDOCUMENT]: AttachDocument,
  [IconsEnum.FOLDER]: Folder,
  [IconsEnum.CAMERA]: Camera,
  [IconsEnum.CHAT]: Chat,
  [IconsEnum.CLOSE]: Close,
  [IconsEnum.DELETE]: Delete,
  [IconsEnum.CLEARFILTER]: ClearFilter,
  [IconsEnum.DRAG]: Drag,
  [IconsEnum.EDIT]: Edit,
  [IconsEnum.EYE]: Eye,
  [IconsEnum.EXPORT]: Export,
  [IconsEnum.MEASUREMENTS]: Measurements,
  [IconsEnum.REDO]: Redo,
  [IconsEnum.RESIZE]: Resize,
  [IconsEnum.SHIELDCHECKED]: ShieldChecked,
  [IconsEnum.UNDO]: Undo,
  [IconsEnum.CALENDAR]: Calendar,
  [IconsEnum.PERSONALINFORMATION]: PersonalInformation,
  [IconsEnum.PATIENTMORPHOLOGY]: PatientMorphology,
  [IconsEnum.MEDICALIMAGE]: MedicalImages,
  [IconsEnum.CLINICALDATA]: ClinicalData,
  [IconsEnum.REPORTS]: Reports,
  [IconsEnum.ACTIVITYTRACKING]: ActivityTracking,
  [IconsEnum.PAINASSESSMENT]: PainAssessment,
  [IconsEnum.SURVEYRESULTS]: SurveyResults,
  [IconsEnum.ARROWUP]: UpArrow,
  [IconsEnum.ARROWDOWN]: DownArrow,
  [IconsEnum.AXIALPLANE]: AxialPlane,
  [IconsEnum.BODYBACK]: BodyBack,
  [IconsEnum.BODYFRONT]: BodyFront,
  [IconsEnum.BODYLAYERS]: BodyLayers,
  [IconsEnum.BRIGHTNESS]: Brightness,
  [IconsEnum.COMPARE]: Compare,
  [IconsEnum.CONTACTFORM]: ContactForm,
  [IconsEnum.CORONALPLANE]: CoronalPlane,
  [IconsEnum.CROP]: Crop,
  [IconsEnum.DUPLICATE]: Duplicate,
  [IconsEnum.EMAIL]: Email,
  [IconsEnum.EXITFULLSCREEN]: ExitFullscreen,
  [IconsEnum.EXPAND]: Expand,
  [IconsEnum.GOBACK]: GoBack,
  [IconsEnum.GRID]: Grid,
  [IconsEnum.HARDWARE]: Hardware,
  [IconsEnum.HIDE]: Hide,
  [IconsEnum.IMPORT]: Import,
  [IconsEnum.JOIN]: Join,
  [IconsEnum.LAYINGPOSITION]: LayingPosition,
  [IconsEnum.LOCK]: Lock,
  [IconsEnum.UNLOCK]: Unlock,
  [IconsEnum.NEXT]: Next,
  [IconsEnum.OSTEOTOMYTOOL]: OsteotomyTool,
  [IconsEnum.PATIENTINDICATORS]: PatientIndicators,
  [IconsEnum.PHONENUMBER]: PhoneNumber,
  [IconsEnum.PHOTO]: Photo,
  [IconsEnum.POSITION]: Position,
  [IconsEnum.PROFILE]: Profile,
  [IconsEnum.REFLECT]: Reflect,
  [IconsEnum.SAGITTALPLANE]: SagittalPlane,
  [IconsEnum.SECURITY]: Security,
  [IconsEnum.SECURITYUNLOCKED]: SecurityUnlocked,
  [IconsEnum.SHOW]: Show,
  [IconsEnum.SITTINGPOSITION]: SittingPosition,
  [IconsEnum.VIDEOCHAT]: Videochat,
  [IconsEnum.WEBSITE]: Website,
  [IconsEnum.DISTANCEGENERIC]: DistanceGeneric,
  [IconsEnum.DISTANCEHORIZONTAL]: DistanceHorizontal,
  [IconsEnum.DISTANCEVERTICAL]: DistanceVertical,
  [IconsEnum.ANGLE]: Angle,
  [IconsEnum.LOGOUT]: Logout,
  [IconsEnum.ANGLEGENERIC]: AngleGeneric,
  [IconsEnum.ANGLEHORIZONTAL]: AngleHorizontal,
  [IconsEnum.ANGLEVERTICAL]: AngleVertical,
  [IconsEnum.ANGLEINNER]: AngleInner,
  [IconsEnum.ANGLE4POINTS]: Angle4Points,
  [IconsEnum.ANGLECOBB]: AngleCOBB,
  [IconsEnum.ANGLECOMP]: AngleComp,
  [IconsEnum.ANGLEKYPHOSIS]: AngleKYPHOSIS,
  [IconsEnum.ANGLELORDOSIS]: AngleLORDOSIS,
  [IconsEnum.OSTEOTOMIES]: Osteotomies,
  [IconsEnum.RODS]: Rods,
  [IconsEnum.RODLEFTENABLED]: RodLeftEnabled,
  [IconsEnum.RODLEFTDISABLED]: RodLeftDisabled,
  [IconsEnum.RODRIGHTENABLED]: RodRightEnabled,
  [IconsEnum.RODRIGHTDISABLED]: RodRightDisabled,
  [IconsEnum.CONFIRM]: Confirm,
  [IconsEnum.ADDVERTEBRA]: AddVertebra,
  [IconsEnum.REMOVEVERTEBRA]: RemoveVertebra,
  [IconsEnum.ADDLANDMARK]: AddLandmark,
  [IconsEnum.INFO]: Info,
  [IconsEnum.SPONDY]: Spondy,
  [IconsEnum.CAGES]: Cages,
  [IconsEnum.DOLLFRONT]: DollFront,
  [IconsEnum.DOLLVERIFIED]: DollVerified,
  [IconsEnum.HISTORY]: History,
  [IconsEnum.HELP]: Help,
  [IconsEnum.DOCUMENTATION]: Documentation,
  [IconsEnum.SUPPORT]: Support,
  [IconsEnum.VIDEO]: Video,
  [IconsEnum.DATAFUSION]: DataFusion,
  [IconsEnum.MODALITYSYNC]: ModalitySync,
  [IconsEnum.SPP]: Spp,
  [IconsEnum.THREE_D]: ThreeD,
  [IconsEnum.RADIODENSITY]: Radiodensity,
  [IconsEnum.DECOMPENSATION]: Decompensation,
  [IconsEnum.FAVORITE]: Favorite,
  [IconsEnum.COMPAREDIGITALTWIN]: CompareDigitalTwin,
  [IconsEnum.RESET]: Reset,
  [IconsEnum.SETTINGS]: Settings,
  [IconsEnum.RESETVIEW]: ResetView,
  [IconsEnum.PEN]: Pen,
  [IconsEnum.BRUSH]: Brush,
  [IconsEnum.ERASER]: Eraser,
  [IconsEnum.CIRCLE]: Circle,
  [IconsEnum.SQUARE]: Square,
  [IconsEnum.CEMARKUDI]: CEMarkUDI,
  [IconsEnum.CEMARKWARMING]: CEMarkWarming,
  [IconsEnum.CEMARKMANUFACTURER]: CEMarkManufacturer,
  [IconsEnum.CEMARKMEDICALDEVICE]: CEMarkMedicalDevice,
  [IconsEnum.CEMARKNOTIFIEDBODY]: CEMarkNotifiedBody,
  [IconsEnum.CEMARKBOOKINFO]: CEMarkBookInfo,
  [IconsEnum.SPINE]: Spine,
  [IconsEnum.DOWNLOAD]: Download,
  [IconsEnum.UPLOAD]: Upload,
};
